module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spinner-parent"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Add new images")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary btn-sm pull-right",
    attrs: {
      "to": {
        name: 'GalleryManageImages',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("\n            Manage Images\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row images-dd__wrap"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__target-zone"
  }, [_c('div', {
    staticClass: "images-dd__target-zone__title"
  }, [_vm._v("\n                  Images which will add to gallery:\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, _vm._l((_vm.selectedImages), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id,
        "title": item.title
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title"
    }, [_vm._v(_vm._s(_vm.shortTitle(item.title)))]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.deleteImage(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus"
    })])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "images-dd__source-wrap spinner-parent"
  }, [_c('div', {
    staticClass: "images-dd__source-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by image title"
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "spinner-parent"
  }, [_c('spinner', {
    ref: "sourceSpinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "images-dd__list"
  }, [_vm._l((_vm.sourceImages), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "images-dd__item",
      attrs: {
        "data-id": item.id
      }
    }, [_c('div', {
      staticClass: "images-dd__item__img"
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__title",
      attrs: {
        "title": item.title
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.shortTitle(item.title)) + "\n                      ")]), _vm._v(" "), _c('div', {
      staticClass: "images-dd__item__cover",
      on: {
        "click": function($event) {
          return _vm.addImage(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })])])
  }), _vm._v(" "), (!_vm.total) ? _c('div', {
    staticClass: "images-dd__list--empty"
  }, [_vm._v("\n                      There are no items on your request\n                    ")]) : _vm._e()], 2), _vm._v(" "), _c('nav', {
    staticClass: "images-dd__source-nav"
  }, [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.changePage
    }
  })], 1)], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 mb-5"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n        Save Images\n        "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "saving-alerts",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          Images have saved successful!\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.saveErrorMessage) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h1', [_vm._v("Image Gallery")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f9ef5a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/content/gallery/AddImages.vue
// module id = 962
// module chunks = 0